/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { QuestionLibraryFilterViewModel } from "../types/QuestionLibraryFilterViewModel.ts";
import { eExamItemStatusSchema } from "./eExamItemStatusSchema.ts";

export const questionLibraryFilterViewModelSchema = z.object({
  startDate: z.string().nullish(),
  endDate: z.string().nullish(),
  labelSearch: z.string().nullish(),
  status: z.optional(
    z
      .lazy(() => eExamItemStatusSchema)
      .describe("1 = Pending | 2 = Approved | 3 = Rejected | "),
  ),
  culturesInfo: z.string().nullish(),
  disciplineId: z.number().int().nullish(),
  personId: z.number().int().nullish(),
  companyId: z.number().int().nullish(),
  componentType: z.number().int().nullish(),
  active: z.boolean().nullish(),
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  sortField: z.string().nullish(),
  sortDirection: z.string().nullish(),
}) as unknown as ToZod<QuestionLibraryFilterViewModel>;
